import { ObjectID } from 'bson';
import { Schema } from 'mongoose';

export interface IMapRouteStep {
  _id: ObjectID;
  action: MapRouteStepAction;
  text: string;
  distanceInMeters: number;
  travelTimeInSeconds: number;
}

export enum MapRouteStepAction {
  walk = 'walk',
  bus = 'bus',
  train = 'train',
  other = 'other',
}

const schema = new Schema({
  action: {
    type: String,
    enum: Object.values(MapRouteStepAction),
    required: true,
  },
  text: {
    type: String,
    required: true,
  },
  distanceInMeters: {
    type: Number,
    required: true,
  },
  travelTimeInSeconds: {
    type: Number,
    required: true,
  },
});

export default schema;
